// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/auto-pan/auto-pan.scss
// module id = 401
// module chunks = 0